import {SearchRouter} from '@/containers/FacetedSearch/Router';
import {SearchQuery} from '@/containers/FacetedSearch/Query';
import {QueryProvider} from '@/containers/FacetedSearch/Provider';

export const FacetedSearchRouter = SearchRouter;
export const FacetedSearchQuery = SearchQuery;
export const SearchQueryProvider = QueryProvider;
